import React from 'react'
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import { MuiDropDown } from "./../components/basicComponent/MuiDropDown";
import MuiButton from "./../components/basicComponent/MuiButton";
import MuiDatePicker from "./../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";
import Header from './../sharedScreens/Header';

const VisaCreate = () => {
  return (
    <div className="grow">
    <SideMenu />
    <div className="wrapper flex grow flex-col">
      <Header />
      <main className="grow content" id="content" role="content">
        <div className="container-fixed">
          <div className="card-header text-center">
            <h3 className="card-title">Visa Create</h3>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card card-custom">
                <div className="card-body">
                  <div className="row mt-4">
               
     
               
                    <div className="col-md-4 mt-3">
                    <MuiSearchSelect
                        placeholder={"Business Unit "}
                        label="Business Unit "
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                    <MuiInput label={'Customer Name'} placeholder='Customer Name'/>
                    </div>
                    <div className="col-md-4 mt-3">
                    <MuiSearchSelect
                        placeholder={"Dest. Country"}
                        label="Dest. Country "
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                    <MuiInput label={'Type of Visa'} placeholder='Type of Visa'/>
                    </div>
                    <div className="col-md-4 mt-3">
                     <MuiInput label={"Fare"} placeholder='Fare'/>
                    </div>
                    <div className="col-md-4 mt-3">
                    <MuiInput label={"Documents"} placeholder='Documents'/>
                    </div>

                    <div className="col-md-4 mt-3">
                    <MuiInput label={"Supporting Documents"} placeholder='Supporting Documents'/>
                    </div>

                    <div className="col-md-4 mt-3">
                    <MuiInput label={"Terms & Conditions"} placeholder='Terms & Conditions'/>
                    </div>
                 
              
            
                    
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        marginTop: "8px",
                      }}
                    >
                      <div className="user-button w-full">
                        <MuiButton className="clear-btn " label="Clear" />
                        <MuiButton
                          className="main-btn get-btn"
                          variant="contained"
                          size="large"
                          type="submit"
                          label={"Retrieve"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div> 
  )
}

export default VisaCreate
